import { trackError } from '@billy/track-error'
import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { QueryKeys } from '../../../enums/queryKeys'
import { getCerfaSignatureLink, GetCerfaSignatureLinkResponse } from '../query-api'

interface UseGetCerfaSignatureLinkOptions {
  onError?: () => void
  onSuccess?: (data: GetCerfaSignatureLinkResponse) => void
}

export const useGetCerfaSignatureLink = ({ onError, onSuccess }: UseGetCerfaSignatureLinkOptions) => {
  const { organization } = useUserOrganization()
  const network = 'PDP'

  const { data: response, isLoading } = useQuery<GetCerfaSignatureLinkResponse>(
    [QueryKeys.EInvoicingGetCerfaSignatureLink, network, organization?.id],
    () => {
      if (!organization?.id) {
        trackError('Organization ID is required to get Cerfa signature link')
        return Promise.resolve({ data: null })
      }
      return getCerfaSignatureLink({ network, targetId: organization.id })
    },
    {
      enabled: !!organization?.id,
      onError,
      onSuccess,
    },
  )

  return {
    data: response?.data,
    isProcessing: isLoading,
  }
}
